import Vue from 'vue';
import Vuex from 'vuex';

import global from './modules/global';
import dashboardRecords from './modules/dashboardRecords';
import diaryListRecords from './modules/diaryListRecords';

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production';

const store = new Vuex.Store({
  modules: {
    global,
    dashboardRecords,
    diaryListRecords,
  },
  strict: debug,
});

export default store;
